import { APP_PREFIX, EDIT_VISIT, VISITS_PAGE } from '@app/routes/urls';

/**
 * The dashboard's route to one visit's edit screen.
 *
 * Built from the route constants rather than a literal, and shared by the surfaces that link
 * to a visit — the map popup, the notes feed and its drawer — so the path is written once.
 */
export const visitEditPath = (visitId: number): string =>
  `/${APP_PREFIX}/${VISITS_PAGE}/${EDIT_VISIT.replace(':id', String(visitId))}`;
